import { Injectable } from '@angular/core';
import { APIService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class InvitedDriverService {

  constructor(private readonly apiService: APIService) { }

  sendInviteToDriver(request){
   return this.apiService.postWithAllResponse('User/InviteDriver',request)
  }
}
